// extracted by mini-css-extract-plugin
module.exports = {"modal":"styles_modal__37V4m","modalBody":"styles_modalBody__1BtEU","title":"styles_title__1aNrS","close":"styles_close__3FRah"};